import Button from "../elements/button";

export default function GeneralCarouselCard({
    title, blurb, primaryButtonRow, imageDirection, imageBackgroundGridOff,
    primaryImageURL, primaryImageALT, secondaryImageURL, secondaryImageALT,
}) {

    return (
        <div className="swiper-slide content-slide">
            <div className="row align-items-start align-items-lg-center">
                <div className="col-6 col-lg-auto position-relative d-flex flex-wrap gap-3">

                    <img
                        className="polaroid img-fluid w-96"
                        src={primaryImageURL}
                        alt={primaryImageALT} />

                    {/* TODO: Delete this image */}
                    {
                        secondaryImageURL &&
                        <img
                            className="polaroid img-fluid"
                            src={secondaryImageURL}
                            alt={secondaryImageALT} />
                    }
                </div>
                <div className="md:col-6 col-lg">
                    <h5 className="text-3xl font-semibold pb-1"> {title} </h5>
                    <p>
                        <span style={{whiteSpace: 'pre-wrap'}}>
                            {blurb}
                        </span>
                    </p>
                    <div>
                        {primaryButtonRow}
                    </div>
                </div>
            </div>
        </div>
    )
}